/** The minimal shape a form must expose for this constraint to run: only `facilityIds` is read. */
type FacilitySelectionShape = {
	readonly facilityIds: readonly number[];
};

/**
 * Generic over the minimal shape it reads, not over `UserFormData` itself, so the FormData never
 * has to import its own constraint back (`guides/forms.md` §1.1).
 */
function hasAtLeastOneFacility<T extends FacilitySelectionShape>(
	value: readonly number[],
	_formData: T,
): boolean {
	return value.length > 0;
}

export default hasAtLeastOneFacility;
